module.exports = __webpack_public_path__ + "img/horizontal_4_5_r_pp2_5012.24bc6038.png";